<template>
  <div>打分时间</div>
</template>

<script>
export default {

}
</script>

<style>

</style>